import { useEffect, useState } from "react";
import ApiTable from "../../../../@ui/ApiTable/ApiTable";
import { ApiTableColumn } from "../../../../types/ApiTable/ApiTableColumn";
import { Feed } from "../../../../types/LayerAdmin/Feed";
import { PublicTransportImportType } from "../../../../constant/PublicTransportImportType";
import { Pagination } from "../../../../types/PaginiationResult";
import { ApiTableState } from "../../../../types/ApiTable/ApiTableState";
import { FilterType } from "../../../../types/ApiTable/ColumnFilter";
import { useParams } from "react-router-dom";
import { usePublicTransportService } from "../../../../hooks";

const FeedsView = () => {
  const publicTransportService = usePublicTransportService();

  const [loading, setLoading] = useState<boolean>(false);
  const [feedsPage, setFeedsPage] = useState<Pagination<Feed>>({
    records: [],
    totalPages: 0,
    page: 1,
  });

  const [requestData, setRequestData] = useState<ApiTableState>({
    pagination: {
      page: 1,
      pageSize: 50,
    },
  });

  const { feedId } = useParams();

  useEffect(() => {
    const id = feedId!;
    const { pagination, sort } = requestData;
    const sortString = `${sort?.field}${
      sort?.direction === "desc" ? "Desc" : ""
    }`;
    setLoading(true);
    publicTransportService
      .GetPublicTransportFeeds(
        id as string,
        pagination.page,
        pagination.pageSize,
        sort ? sortString : "",
      )
      .then((response: Pagination<Feed>) => {
        setFeedsPage(response);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  }, [requestData]);

  const getImportLabel = (importType: PublicTransportImportType) => {
    switch (importType) {
      case PublicTransportImportType.AtocCif:
        return "ATOC";
      case PublicTransportImportType.Traveline:
        return "Traveline";
      case PublicTransportImportType.TransitLand:
        return "TransitLand";
    }
  };

  const cols = [
    {
      field: "fileName",
      label: "Name",
      sortable: true,
      filter: {
        type: FilterType.TEXT,
        placeholder: "Search name",
      },
      renderContents: (value: Feed) => <>{value.name}</>,
      style: { width: "80%" },
    },
    {
      field: "routeCount",
      label: "Route Count",
      sortable: true,
      renderContents: (value: Feed) => <>{value.routeCount}</>,
      style: { width: "10%" },
    },
    {
      field: "importType",
      label: "Import Type",
      sortable: true,
      renderContents: (value: Feed) => <>{getImportLabel(value.importType)}</>,
      style: { width: "10%" },
    },
  ] as ApiTableColumn[];

  return (
    <>
      {" "}
      <ApiTable
        loading={loading}
        state={requestData}
        pageOptions={[10, 20, 50]}
        data={feedsPage}
        columns={cols}
        onChange={setRequestData}
      />
    </>
  );
};

export default FeedsView;
